import { useState, useEffect, createContext, useContext } from "react";
import { toast } from "sonner";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem('cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems(prev => {
      const existing = prev.find(i => i.id_product === product.id_product);
      if (existing) {
        return prev.map(i => i.id_product === product.id_product 
          ? { ...i, quantity: i.quantity + qty }
          : i
        );
      }
      return [...prev, { ...product, quantity: qty }];
    });
    toast.success(`${product.name} přidáno do košíku`);
  };

  const updateQuantity = (productId, qty) => {
    if (qty <= 0) {
      removeItem(productId);
      return;
    }
    setItems(prev => prev.map(i => i.id_product === productId ? { ...i, quantity: qty } : i));
  };

  const removeItem = (productId) => {
    setItems(prev => prev.filter(i => i.id_product !== productId));
    toast.info('Produkt odebrán z košíku');
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((sum, i) => sum + (i.price_vat * i.quantity), 0);
  const itemCount = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQuantity, removeItem, clearCart, total, itemCount }}>
      {children}
    </CartContext.Provider>
  );
}
